import http from "./http";
import { triggerCallLoading } from "./EventBus";


var _username = '';
export function getUsername() {
  return _username;
}
function _loadUsername() {
  _username = localStorage.getItem('_uname');
}

async function InitiateApp() {
  try {
    _loadUsername();
    await Promise.all([
      _loadBookIdx(),
      _loadGrammaFilter(),
      _loadGrammaTagsFilter(),
      _loadWordFilter(),
      _loadWordTagsFilter(),
    ])
    console.log('Init 异步结结束')
  } catch (err) {
    console.error(err);
  }
}
export async function InitDownloadBook() { //被Main.js调用
  await InitiateApp();
  await getBookList(true);
  if (_curSelectedBookIdx >= _curBookList.length) _curSelectedBookIdx = -1;
  if (_curSelectedBookIdx === -1) {
    await downloadGrammaTags();
    await downloadGrammaByFilter();
  } else {
    await initDownloadBookTags();
    await downloadWordBookByFilter();
  }
}
const _displayGrammaTop = {
  level_min: 1,
  level_max: 5,
  roots: [],
  preps: [],
  forms: []
}
const _displayWordTop = {
  bookName: '',
  level_min: 1,
  level_max: 5,
  tags: [],
}
export function curBookInfo() {

  if (_curSelectedBookIdx === -1) {
    return {
      bGrammaBook: true,
      ..._displayGrammaTop,
      arrange: filterWrap.cur_gramma_filter.arrange,
    }
  } else {
    return {
      bGrammaBook: false,
      ..._displayWordTop,
      arrange: filterWrap.cur_word_filter.arrange,
    }
  }
}

//#region My部分数据
let _curSelectedBookIdx = -1; //-1是默认值,即为语法本,0~...是单词本
async function _loadBookIdx() {
  _curSelectedBookIdx = Number(localStorage.getItem('_curSelectedBook'))
  if (_curSelectedBookIdx === null) {
    console.log("获取_curSelectedBook失败,创建值为-1")
    localStorage.setItem('_curSelectedBook', -1)
  } else { }
}
async function deleteRedundancyGrammaTags() {
  var res = await http.get('/gramma/redundancy')
  console.log('清楚冗余gramma tags, res = ', res)
}
async function deleteRedundancyWordTags() {
  var res = await http.get('/word/redundancy')
  console.log('清楚冗余word tags, res = ', res)
}
export function getCurSelectedBook() {
  return _curSelectedBookIdx
}
export async function setCurSelectedBook(bookIndex) {
  _curSelectedBookIdx = bookIndex
  localStorage.setItem('_curSelectedBook', bookIndex)
  //请求服务器数据
  if (bookIndex === -1) {
    await downloadGrammaBook()
    await downloadGrammaTags()
  } else {
    // var __bookName = _curBookList[_curSelectedBookIdx].name;
    // await getBook(__bookName);
    await initDownloadBookTags();
    await downloadWordBookByFilter();
    _needRefreshWordList = true;
  }
}
export async function refreshData() {
  if (_curSelectedBookIdx === -1) {
    await deleteRedundancyGrammaTags();
    await deleteRedundancyWordTags();
    // downloadGrammaBook();
    // downloadGrammaTags();
  }
}

//#endregion

//#region 单词本数据
var _needRefreshWordList = false;
export function needRefreshWordList() {
  let need = _needRefreshWordList;
  _needRefreshWordList = false;
  return need;
}
var _curBookList = [];
export const wordWrap = {
  list: [],
  cur_edit_word: {},
  level_min: 1,
  level_max: 5,
  tags: [],
}
// 1 获取book列表
export async function getBookList(needDownload) {
  if (needDownload) {
    triggerCallLoading(true);
    try {
      var re = await http.get('/word/getbooklist');
      _curBookList = re.data;
    } catch (err) {
      console.error(err);
    } finally {
      triggerCallLoading(false);
    }
  }
  return _curBookList;
}
// 2 添加BOOK
export async function addBook(bookName) {
  var b = false;
  for (const item of _curBookList) {
    if (item.name === bookName) {
      b = true;
      break;
    }
  }
  if (b) {
    return false;
  } else {
    triggerCallLoading(true);
    try {
      var res = await http.get('/word/addbook', { params: { 'name': bookName } });
      console.log('添加book结果 === ', res.data);
      if (res.data !== false) {
        _curBookList.push({ id: res.data, name: bookName });
      }
      return true;
    } catch (err) {
      console.error(err);
      return false;
    } finally {
      triggerCallLoading(false);
    }
  }
}
// 3 更改BOOK的名称
export async function editBookName(curBookName, newName) {
  triggerCallLoading(true);
  try {
    var res = await http.get('/word/editbook',
      { params: { 'oldName': curBookName, 'newName': newName } });
    console.log('修改名称，res===', res);
    return res.data.success;
  } catch (err) {
    console.error(err);
    return false;
  } finally {
    triggerCallLoading(false);
  }
}
// 4 删除book
export async function deleteBook(bookName) {
  triggerCallLoading(true);
  try {
    var res = await http.get('/word/deletebook', { params: { 'bookName': bookName } });
    if (res.data.success) {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    console.error(err);
    return false;
  } finally {
    triggerCallLoading(false);
  }
}
//6 添加一个word
export async function addWord(word, callback) {
  if (_curSelectedBookIdx >= 0) {
    word.book = _curBookList[_curSelectedBookIdx].name;
  }
  word.tags = []
  _checkNewTagsAdding(word.tags, wordTagWrap);

  console.log('states::准备添加一个word', word)


  if (word === null || word.word === null || word.book == null) return false;
  if (word.level === null) word.level = 1;
  triggerCallLoading(true);
  try {
    var res = await http.get('/word/addword', { params: { 'word': JSON.stringify(word) } });
    console.warn('添加完word的res = ', res);
    await downloadWordBookByFilter();
    await downloadWordTagByBook();
    callback?.(true);
  } catch (err) {
    console.error(err);
    callback?.(false);
    return false;
  } finally {
    triggerCallLoading(false);
  }
}

//8 意思没用到这个函数 在main里用http下载了根据ID获取一整个word的所有信息
export async function getWordByID(wordID) {
  triggerCallLoading(true);
  try {
    var res = await http.get('/word/getbyid', { params: { 'id': wordID } });
    return res;
  } catch (err) {
    console.error(err);
    return false;
  } finally {
    triggerCallLoading(false);
  }
}
//9 修改一个word
export async function UpdateWord(word, callback) {
  if (!word || word.word === null) {
    callback?.(false)
    return
  }

  console.log('上传修改的word:', word)

  triggerCallLoading(true)
  var res = await http.post('/word/update', { word })
  console.log('结果是:', res)
  triggerCallLoading(false)
  if (res.data && res.data.success === true) {
    //准备tags
    let newTags = []
    _checkNewTagsAdding(newTags, wordTagWrap)

    //上传tags
    triggerCallLoading(true)
    let editWord = {
      id: word.id,
      tags: newTags,
    }
    var re = await http.post('/word/settag', { editWord })
    console.log('添加tag的回答re=', re)
    triggerCallLoading(false)

    callback?.(true)
    return
  }
  callback?.(false)
}
//10 根据FILTER 和 BOOK 删选下载一个BOOK
export async function downloadWordBookByFilter(callback) {
  if (!_curBookList[_curSelectedBookIdx]) {
    callback?.(false)
    return;
  }
  let _tags = []
  wordTagWrap.list.forEach((item) => {
    if (item.selected) _tags.push(item.name)
  })
  let _filter = {
    level_min: filterWrap.cur_word_filter.level_min || 1,
    level_max: filterWrap.cur_word_filter.level_max || 5,
    bookName: _curBookList[_curSelectedBookIdx].name,
    tags: _tags,
  }
  _displayWordTop.level_min = _filter.level_min;
  _displayWordTop.level_max = _filter.level_max;
  _displayWordTop.bookName = _filter.bookName;
  _displayWordTop.tags = structuredClone(_filter.tags);
  console.warn('准备通过filter查询word，最终filter = ', _filter);
  triggerCallLoading(true);
  try {
    var _res = await http.get('/word/getwordbyfilter', { params: { filter: JSON.stringify(_filter) } })
    var res = JSON.parse(_res.data);

    wordWrap.list = res;
    //保存tags到localStorage
    localStorage.setItem('_selectedwordTags', JSON.stringify(_tags));
    console.warn('根据filter删选word，res=', res)
    callback?.(true);
  } catch (err) {
    console.error(err);
    callback?.(false);
  } finally {
    triggerCallLoading(false);
  }


}

//book 的 tags相关
var wordTags = [];
function downloadCurWordTags() {
  wordTagWrap.list = []
  var k = 0
  if (localStorageFilters.wordTags.length === 0) {
    wordTags.forEach((item) => {
      wordTagWrap.list.push({
        key: k,
        name: item,
        selected: true,
      })
      k++
    })
  } else {
    wordTags.forEach((item) => {
      wordTagWrap.list.push({
        key: k,
        name: item,
        selected: localStorageFilters.wordTags.includes(item),
      })
      k++
    })
  }
}
//根据BOOK NAME 返回所有的tags
export async function getAllTagsByBook(bookName) {
  try {
    var res = await http.get('/word/gettagsbybook', { params: { bookName: bookName } });
    console.warn('已下载BOOK：', bookName, ' 的tags：', res);
    wordTags = JSON.parse(res.data);
    downloadCurWordTags();

  } catch (err) {
    throw err;
  }
}


//#endregion

//#region Filter Word 部分数据
export const wordTagWrap = {
  list: [],
  listAdd: [],
}
const filter_default_word = {
  arrange: 'default',
  level_min: 1,
  level_max: 5,
  display: 'all',
}
async function _loadWordFilter() {
  var saved = localStorage.getItem('_curWordFilter');
  filterWrap.cur_word_filter = saved ? JSON.parse(saved) : filter_default_word;
  if (!saved) {
    console.log("获取_curWordFilter保存数据失败, 创建默认值")
    localStorage.setItem('_curWordFilter', JSON.stringify(filterWrap.cur_word_filter))
  }
}
async function _loadWordTagsFilter() {
  var _selectedWordTags = localStorage.getItem('_selectedWordTags');
  if (!_selectedWordTags) {
    console.log("获取本地存档的gramma root失败，创建默认值[]");
    localStorage.setItem('_selectedWordTags', JSON.stringify([]));
    _selectedWordTags = localStorage.getItem('_selectedWordTags');
  }
  localStorageFilters.roots = JSON.parse(_selectedWordTags);
}
export async function downloadWordTagByBook() {
  if (_curSelectedBookIdx === -1) return;
  console.warn('下载当前book的tag,_curIdx=', _curSelectedBookIdx);
  await getAllTagsByBook(_curBookList[_curSelectedBookIdx].name);
}
async function initDownloadBookTags() {
  await getAllTagsByBook(_curBookList[_curSelectedBookIdx].name);
}
// #endregion



//#region  通用 
function saveFilter() {
  localStorage.setItem('_curGrammaFilter', JSON.stringify(filterWrap.cur_gramma_filter))
  localStorage.setItem('_curWordFilter', JSON.stringify(filterWrap.cur_word_filter))
}

const localStorageFilters = {
  roots: [],
  preps: [],
  forms: [],
  wordTags: [],
}
export const filterWrap = {
  cur_gramma_filter: {},
  cur_word_filter: {},
  saveFilter: saveFilter,
}
const filter_default_gramma = {
  arrange: 'default',
  level_min: 1,
  level_max: 5,
  display: 'all', //all 全显示 none 全不显示 fix 补充 body 主体 definition 解释
}

//#endregion


//#region  语法Gramma功能 




export const grammasWrap = {
  // gramma , disp_gramma , left , right , disp_side ,
  // definition , disp_difinition , note
  list: [],
  cur_edit_gramma: {},
}

var rootTags = ['111', '22', '33333', '4444', '555555', '666666']

export const prepTagsWrap = {
  list: [],
  listAdd: [],
  // listNew: []
}
var prepTags = ['P1111', 'P222', 'P333', 'P444', 'P555', 'P666']

export const formTagsWrap = {
  list: [],
  listAdd: [],
  // listNew: []
}
var formTags = ['fff1', 'Pff222', 'ffP333', 'P44ff4', 'P5ff55', 'P6ff66']

export async function downloadGrammaListByFilter(filter) {
  triggerCallLoading(true)
  var re = await http.get('/gramma/grammalist', {
    params: {
      filter: JSON.stringify(filter)
    }
  });
  triggerCallLoading(false)
  console.log('下载语法book，BY FILTER ，re=', re)
  return re
}

async function _loadGrammaFilter() {
  var saved = localStorage.getItem('_curGrammaFilter');
  filterWrap.cur_gramma_filter = saved ? JSON.parse(saved) : filter_default_gramma;
  if (!saved) {
    console.log("获取_curGrammaFilter保存数据失败, 创建默认值")
    localStorage.setItem('_curGrammaFilter', JSON.stringify(filterWrap.cur_gramma_filter))
  }
}
async function _loadGrammaTagsFilter() {
  var _selectedGrammaRoots = localStorage.getItem('_selectedGrammaRoots');
  if (!_selectedGrammaRoots) {
    console.log("获取本地存档的gramma root失败，创建默认值[]");
    localStorage.setItem('_selectedGrammaRoots', JSON.stringify([]));
    _selectedGrammaRoots = localStorage.getItem('_selectedGrammaRoots')
  }
  localStorageFilters.roots = JSON.parse(_selectedGrammaRoots);


  var _selectedGrammaPreps = localStorage.getItem('_selectedGrammaPreps');
  if (!_selectedGrammaPreps) {
    console.log("获取本地存档的gramma preps失败，创建默认值[]");
    localStorage.setItem('_selectedGrammaPreps', JSON.stringify([]));
    _selectedGrammaPreps = localStorage.getItem('_selectedGrammaPreps');
  }
  localStorageFilters.preps = JSON.parse(_selectedGrammaPreps);

  var _selectedGrammaForms = localStorage.getItem('_selectedGrammaForms');
  if (!_selectedGrammaForms) {
    console.log("获取本地存档的gramma forms失败，创建默认值[]");
    localStorage.setItem('_selectedGrammaForms', JSON.stringify([]));
    _selectedGrammaForms = localStorage.getItem('_selectedGrammaForms');
  }
  localStorageFilters.forms = JSON.parse(_selectedGrammaForms);
}

export async function downloadGrammaByFilter(callback) {
  let needCallServer = true;
  if (needCallServer) {
    let _roots = []
    rootTagsWrap.list.forEach((item) => {
      if (item.selected) _roots.push(item.name)
    })
    let _preps = []
    prepTagsWrap.list.forEach((item) => {
      if (item.selected) _preps.push(item.name)
    })
    let _forms = []
    formTagsWrap.list.forEach((item) => {
      if (item.selected) _forms.push(item.name)
    })
    let _filter = {
      level_min: filterWrap.cur_gramma_filter.level_min,
      level_max: filterWrap.cur_gramma_filter.level_max,
      roots: _roots,
      preps: _preps,
      forms: _forms,
    }
    _displayGrammaTop.level_min = _filter.level_min;
    _displayGrammaTop.level_max = _filter.level_max;
    _displayGrammaTop.roots = structuredClone(_filter.roots);
    _displayGrammaTop.preps = structuredClone(_filter.preps);
    _displayGrammaTop.forms = structuredClone(_filter.forms);
    console.log('通过filter下载gramma book，最终的filter=', _filter)
    var res = await downloadGrammaListByFilter(_filter)
    if (res.data.success) {
      if (res.data.data) {
        grammasWrap.list = res.data.data
        //保存tags到localStorage
        localStorage.setItem('_selectedGrammaRoots', JSON.stringify(_roots));
        localStorage.setItem('_selectedGrammaPreps', JSON.stringify(_preps));
        localStorage.setItem('_selectedGrammaForms', JSON.stringify(_forms));
      } else {
        grammasWrap.list = []
      }
      callback?.(true)
    } else {
      callback?.(false)
    }
  }
}

export async function downloadGrammaTags() {
  triggerCallLoading(true)
  var res = await http.get('/gramma/taglist')
  console.log('下载的tags res = ', res)
  rootTags = res.data.data.roots;
  prepTags = res.data.data.preps;
  formTags = res.data.data.forms;

  downloadCurRootTags();
  downloadCurPrepTags();
  downloadCurFormTags();

  triggerCallLoading(false)
}
export const rootTagsWrap = {
  list: [],
  listAdd: [],
}

function downloadCurRootTags() {
  rootTagsWrap.list = []
  var k = 0
  if (localStorageFilters.roots.length === 0) {
    rootTags.forEach((item) => {
      rootTagsWrap.list.push({
        key: k,
        name: item,
        selected: true,
      })
      k++
    })
  } else {
    rootTags.forEach((item) => {
      rootTagsWrap.list.push({
        key: k,
        name: item,
        selected: localStorageFilters.roots.includes(item),
      })
      k++
    })
  }

  console.log("下载了Root列表")
}

function downloadCurPrepTags() {
  prepTagsWrap.list = []
  var k = 0
  console.log('local preps = ', localStorageFilters.preps)
  if (localStorageFilters.preps.length === 0) {
    prepTags.forEach((item) => {
      prepTagsWrap.list.push({
        key: k,
        name: item,
        selected: true,
      })
      k++
    })
  } else {
    prepTags.forEach((item) => {
      prepTagsWrap.list.push({
        key: k,
        name: item,
        selected: localStorageFilters.preps.includes(item),
      })
      k++
    })
  }


  console.log("下载了prep列表")
}

function downloadCurFormTags() {
  formTagsWrap.list = []
  var k = 0
  if (localStorageFilters.forms.length === 0) {
    formTags.forEach((item) => {
      formTagsWrap.list.push({
        key: k,
        name: item,
        selected: true,
      })
      k++
    })
  } else {
    formTags.forEach((item) => {
      formTagsWrap.list.push({
        key: k,
        name: item,
        selected: localStorageFilters.forms.includes(item),
      })
      k++
    })
  }

  console.log("下载了form列表")
}

export async function downloadGrammaBook(callback) {
  console.log('开始下载语法list')
  triggerCallLoading(true)
  var { data } = await http.get('/gramma/grammalist')
  if (data.data !== null) {
    grammasWrap.list = data.data
  } else {
    grammasWrap.list = []
  }
  console.log('语法list下载完毕', grammasWrap.list)
  triggerCallLoading(false)
}
//http添加gramma,服务器端会检查是否有新的tag并添加
function _checkNewTagsAdding(newArr, warp) {
  warp.listAdd.forEach(i => {
    if (i.selected) newArr.push(i.name)
  })
}
export async function UploadNewGramma(gramma, callBack) {
  if (!gramma || gramma.gramma === null) {
    callBack?.(false)
    return
  }
  gramma.root = []
  _checkNewTagsAdding(gramma.root, rootTagsWrap)
  gramma.prep = []
  _checkNewTagsAdding(gramma.prep, prepTagsWrap)
  gramma.form = []
  _checkNewTagsAdding(gramma.form, formTagsWrap)

  console.log('准备添加gramma:', gramma)

  triggerCallLoading(true)
  var res = await http.post('/gramma/add', { gramma })
  console.log('结果是:', res)
  if (res.data && res.data.success === true) {
    await downloadGrammaBook();
    await downloadGrammaTags();
    callBack?.(true)
    triggerCallLoading(false)
    return
  } else {
    triggerCallLoading(false)
  }
  callBack?.(false)
}
export async function UpdateGramma(gramma, callback) {
  if (!gramma || gramma.gramma === null) {
    callback?.(false)
    return
  }

  console.log('上传修改的gramma:', gramma)

  triggerCallLoading(true)
  var res = await http.post('/gramma/update', { gramma })
  console.log('结果是:', res)
  triggerCallLoading(false)
  if (res.data && res.data.success === true) {
    //准备tags
    let newRoot = []
    _checkNewTagsAdding(newRoot, rootTagsWrap)
    let newPrep = []
    _checkNewTagsAdding(newPrep, prepTagsWrap)
    let newForm = []
    _checkNewTagsAdding(newForm, formTagsWrap)
    //上传tags
    triggerCallLoading(true)
    let editGramma = {
      id: gramma.id,
      roots: newRoot,
      preps: newPrep,
      forms: newForm
    }
    var re = await http.post('/gramma/settag', { editGramma })
    console.log('添加tag的回答re=', re)
    triggerCallLoading(false)

    callback?.(true)
    return
  }
  callback?.(false)
}

export async function DeleteGramma(grammaID, callback) {
  var res = await http.get('/gramma/delete', { params: { grammaID: grammaID } });
  var b = res.data.success
  console.log('删除,res=', res.data.success);
  callback?.(b)
}
//#endregion

//#region  单词Word功能 
export async function DeleteWord(wordID, callback) {
  try {
    console.warn('准备删除word，id=', wordID)
    var res = await http.get('/word/deleteword', { params: { id: wordID } });
    console.log('删除单词结果：', res);
    callback?.(res.data.success);
  } catch (err) {
    console.log(err.message);
    callback?.(false)
  }
}
//#endregion

//#region  Filter功能 

//#endregion
